module.exports = __webpack_public_path__ + "static/media/rsz_godzilla.d2e60311.webp";